import React from 'react'
import { Outlet, Link } from 'react-router-dom'
import { Zap } from 'lucide-react'
import { Footer } from './Footer'

/**
 * PublicLayout provides the landing header/branding and compliance footer 
 * for non-authenticated pages (Login, Register, and Legal compliance).
 */
export const PublicLayout: React.FC = () => {
  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'var(--color-bg)',
        transition: 'background-color var(--transition-base)',
      }}
    >
      {/* Brand Header */}
      <header
        style={{
          width: '100%',
          backgroundColor: 'var(--color-surface)',
          borderBottom: '1px solid var(--color-border-subtle)',
          padding: 'var(--space-4) var(--space-8)',
          transition: 'background-color var(--transition-base), border-color var(--transition-base)',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-3)',
              textDecoration: 'none',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                backgroundColor: 'var(--color-accent)',
                borderRadius: 'var(--radius-md)',
                color: 'white',
              }}
            >
              <Zap size={16} strokeWidth={2.5} />
            </div>
            <span
              style={{
                fontSize: 'var(--text-base)',
                fontWeight: 'var(--font-bold)',
                color: 'var(--color-text-primary)',
                letterSpacing: '-0.02em',
              }}
            >
              NoTimeToDelay &middot; Link2Earn
            </span>
          </Link>

          <div>
            <Link
              to="/login"
              style={{
                fontSize: 'var(--text-sm)',
                fontWeight: 'var(--font-medium)',
                color: 'var(--color-accent)',
                textDecoration: 'none',
              }}
              onMouseOver={(e) => (e.currentTarget.style.color = 'var(--color-accent-hover)')}
              onMouseOut={(e) => (e.currentTarget.style.color = 'var(--color-accent)')}
            >
              Go to Dashboard &rarr;
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main style={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
export default PublicLayout
